var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGraypallet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 26,
    viewBox: "0 0 22 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 26H2.44444V22.75H9.77778V26H12.2222V22.75H19.5556V26H22V17.875H19.5556V19.5H17.1111V17.875H14.6667V19.5H12.2222V17.875H9.77778V19.5H7.33333V17.875H4.88889V19.5H2.44444V17.875H0M2.44444 14.625H19.5556V0H2.44444V14.625Z",
    fill: "#757575"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraypallet);
export default __webpack_public_path__ + "static/media/graypallet.237863b2479b0586ae40a28611a10136.svg";
export { ForwardRef as ReactComponent };